import AxiosConfig from '../../../config/AxiosConfig';

const useUpdateSavTracking = () => {
  const updateSavTracking = async (savRef, data) => {
    try {
      const response = await AxiosConfig.create(
        'put',
        `/orders/sav/${savRef}/updateTracking`
      )
        .call(data)
        .getResponseData();

      return response;
    } catch (err) {
      console.error('Failed to update SAV tracking:', err);
      throw new Error(`updateSavTracking failed: ${err?.message}`);
    }
  };

  return {
    updateSavTracking,
  };
};

export default useUpdateSavTracking;
